export default function CinematicSection() {
  return (
    <section className="relative h-[60vh] md:h-[70vh] lg:h-[80vh] min-h-[400px] overflow-hidden bg-background-950">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/4b3628b182ad10c089c4ada0dac55289.png"
          alt="Notranjost gostilne Marta v večerni svetlobi"
          title="Gostilna Marta – prijetna notranjost"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-black/55"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-5 text-center">
        <h2 className="cinematic-animate font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight max-w-4xl">
          Dobra hrana združuje ljudi.
        </h2>
        <p className="cinematic-animate font-heading text-lg sm:text-xl md:text-2xl text-white/70 italic mt-4 md:mt-6">
          Pri nas vedno diši po domače.
        </p>
      </div>
    </section>
  );
}